import { withHook } from 'utils/withHook';
import { useCompetitionsArticleState } from 'containers/CompetitionsArticle/logic/useCompetitionsArticleState';
import { CompetitionsArticleView } from 'containers/CompetitionsArticle/view/CompetitionsArticleView';

export const CompetitionsArticle = withHook(useCompetitionsArticleState)(
  CompetitionsArticleView
);
